import actions from './actions';

const {
  ADD_BEGIN,
  ADD_SUCCESS,
  ADD_ERR,

  UPLOAD_BEGIN,
  UPLOAD_SUCCESS,
  UPLOAD_ERR,

  READ_BEGIN,
  READ_SUCCESS,
  READ_ERR,

  UPDATE_BEGIN,
  UPDATE_SUCCESS,
  UPDATE_ERR,

  DELETE_BEGIN,
  DELETE_SUCCESS,
  DELETE_ERR,

  SINGLE_DATA_BEGIN,
  SINGLE_DATA_SUCCESS,
  SINGLE_DATA_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const userReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPLOAD_BEGIN:
      return {
        ...state,
        fileLoading: true,
      };

    case UPLOAD_SUCCESS:
      return {
        ...state,
        url: data,
        error: false,
        fileLoading: false,
      };

    case UPLOAD_ERR:
      return {
        ...state,
        error: err,
        fileLoading: false,
      };

    case ADD_BEGIN:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };

    case ADD_SUCCESS:
      return {
        ...state,
        data: null,
        error: false,
        loading: false,
      };

    case ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
        data: null,
      };

    case READ_BEGIN:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };

    case READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
        data: null,
      };

    case DELETE_BEGIN:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };

    case DELETE_SUCCESS:
      return {
        ...state,
        error: false,
        data: null,
        loading: false,
      };

    case DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
        data: null,
      };

    case UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };

    case UPDATE_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        data: null,
      };

    case UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
        data: null,
      };

    default:
      return state;
  }
};

const userSingleReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SINGLE_DATA_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case SINGLE_DATA_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case SINGLE_DATA_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { userReducer, userSingleReducer };
